// QA override, toggled from the State Viewer (Quick Actions → Region Block):
// forces the next login to be treated as an account from a blocked region so
// the RegionBlocked interstitial can be reviewed without an Adobe account
// registered outside the US/Canada.
// One-shot by design — the flag clears itself when it fires, so a forgotten
// toggle can never lock anyone out of their own app: once the interstitial
// has shown, a refresh (or sign out + sign in) returns to normal.

const FORCE_REGION_BLOCK_KEY = 'beaconDebugForceRegionBlock';

// France stands in for "any blocked country"; the real country allowlist
// lives in allowedCountries.ts.
export const FORCED_REGION_BLOCK_COUNTRY = 'FR';

export const isRegionBlockForced = (): boolean =>
	localStorage.getItem(FORCE_REGION_BLOCK_KEY) === 'true';

export const setRegionBlockForced = (forced: boolean): void => {
	if (forced) {
		localStorage.setItem(FORCE_REGION_BLOCK_KEY, 'true');
	} else {
		localStorage.removeItem(FORCE_REGION_BLOCK_KEY);
	}
};

// Clear the one-shot flag. Kept separate from isRegionBlockForced() so that
// *reading* the flag has no side effect: the IMS init effect runs twice under
// React StrictMode (dev), and a read-that-also-clears would let the first run
// consume the flag while the second sees it already gone. Callers read with
// isRegionBlockForced() and clear here only once the block actually commits.
export const clearForcedRegionBlock = (): void => {
	localStorage.removeItem(FORCE_REGION_BLOCK_KEY);
};
